/* TODO: Удалить строки с игнорированием TS в задаче PUB-4328 (Оптимизация обработки кодов) */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { computed, type Ref } from 'vue'
import { codeIs } from '@/lib/codes'


export function useFilteredCodes(allCodes: Ref<any>, idField = 'id') {
  const feedAndPub = computed(() => {
    return Object.values(allCodes.value)
      .filter(
        (code) =>
          codeIs.publication(code)
          || codeIs.feed(code)
          || codeIs.periodical(code),
      )
      .reduce((acc, code) => {
        acc[code[idField]] = code
        return acc
      }, {})
  })

  const feedAndPubIds = computed(() => Object.keys(feedAndPub.value ?? {}))

  const nonFeed = computed(() => {
    return Object.values(allCodes.value)
      .filter(
        (code) =>
          !codeIs.publication(code)
          && !codeIs.feed(code)
          && !codeIs.periodical(code),
      )
      .reduce((acc, code) => {
        acc[code[idField]] = code
        return acc
      }, {})
  })

  const nonFeedIds = computed(() => Object.keys(nonFeed.value ?? {}))

  return {
    feedAndPub,
    feedAndPubIds,
    nonFeed,
    nonFeedIds,
  }
}
